'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ['balloonclose', 'balloonopen', 'beforedrag', 'beforedragstart', 'click', 'contextmenu', 'dblclick', 'geometrychange', 'hintclose', 'hintopen', 'mapchange', 'mousedown', 'mouseenter', 'mouseleave', 'mousemove', 'mouseup', 'multitouchend', 'multitouchmove', 'multitouchstart', 'optionschange', 'overlaychange', 'parentchange', 'propertieschange', 'wheel', 'drag', 'dragend', 'dragstart', 'editorstatechange'];


//////////////////
// WEBPACK FOOTER
// ./~/yandex-map-react/lib/apiEventsLists/geoObject.js
// module id = 1145
// module chunks = 0